import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { mapComponentSetZoomToBounds } from '~/store/frontendState/mapComponent/mapComponent.actionCreators';
import { useMapSettingsPlacesSearchesSelector } from '~/store/mapSettings/places/mapSettingsPlaces.selectors';
import type { PlacesSearchId } from '~/store/mapSettings/places/mapSettingsPlaces.state';
import { convertPlacesSearchToBoundingBox } from './places.helpers';

export const usePlacesHelpers = () => {
  const dispatch = useDispatch();
  const placesSearches = useMapSettingsPlacesSearchesSelector();

  const zoomToPlacesSearchArea = useCallback((placesSearchId: PlacesSearchId) => {
    const placesSearch = placesSearches.find(search => search.id === placesSearchId);
    if (placesSearch) {
      const bounds = convertPlacesSearchToBoundingBox(placesSearch);
      dispatch(mapComponentSetZoomToBounds(bounds));
    }
  }, [dispatch, placesSearches]);

  return {
    zoomToPlacesSearchArea,
  };
};
